module.exports = __webpack_public_path__ + "static/kwec-logo-dark-d513cef27e531b579a9b19caf1312e9d.png";